import React from "react";
import '../About.css';
import ab1 from '../components/Images/ab1.png';
function About() {
  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h1 className="display-4 fw-bold">🚗 About Dream Rent Cars</h1>
        <p className="lead">
          Where Luxury Meets the Road – Rent your dream car today!
        </p>
      </div>

      <div className="row align-items-center mb-5">
        <div className="col-md-6">
          <img
            src={ab1}
            alt="Our Fleet"
            className="img-fluid rounded shadow"
          />
        </div>
        <div className="col-md-6">
          <h2 className="fw-bold">Who We Are</h2>
          <p>
            At <strong>Dream Rent Cars</strong>, we believe in providing more
            than just a vehicle — we offer an experience. From luxury sedans to
            sports cars, our fleet is designed to match your style, comfort, and
            budget.
          </p>
          <p>
            Founded in 2020, our mission is to make premium cars accessible to
            everyone, whether it's a business trip, vacation, or a special
            occasion.
          </p>
        </div>
      </div>

      <div className="row text-center mb-5">
        <div className="col-md-4">
          <h3>🌟 Trusted Service</h3>
          <p>Rated 4.9/5 by thousands of happy renters across the country.</p>
        </div>
        <div className="col-md-4">
          <h3>🛡️ Fully Insured</h3>
          <p>
            All rentals come with complete insurance coverage and roadside
            assistance.
          </p>
        </div>
        <div className="col-md-4">
          <h3>⚡ Instant Booking</h3>
          <p>
            Book your ride in just 3 clicks. No hidden charges, no surprises.
          </p>
        </div>
      </div>

      <div className="bg-dark text-white p-5 rounded">
        <h2 className="text-center mb-4">Why Choose Us?</h2>
        <ul className="list-unstyled fs-5">
          <li>✅ Wide Range of Premium & Economy Cars</li>
          <li>✅ 24/7 Customer Support</li>
          <li>✅ Flexible Pickup & Drop Locations</li>
          <li>✅ Transparent Pricing and Zero Cancellation Fee</li>
        </ul>
      </div>
    </div>
  );
}

export default About;
